"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRNG = void 0;
class PRNG {
    static DEFAULT_SEED = 12345;
    _seed;
    constructor(seed = PRNG.DEFAULT_SEED) {
        this.seed = seed;
    }
    set seed(value) {
        if (!Number.isSafeInteger(value))
            throw new Error("seed must be a safe integer");
        const normalized = value >>> 0;
        this._seed = Math.imul(741103597, normalized || PRNG.DEFAULT_SEED) >>> 0;
    }
    getRandom() {
        this._seed = Math.imul(741103597, this._seed) >>> 0;
        return Math.floor(1e5 * (this._seed / 2 ** 32)) / 1e5;
    }
    getState() {
        return this._seed;
    }
    restoreState(state) {
        if (!Number.isInteger(state) || state <= 0 || state > 0xffffffff) {
            throw new Error("PRNG state must be a nonzero unsigned 32-bit integer");
        }
        this._seed = state;
    }
    getInt(min, max) {
        if (!Number.isSafeInteger(min) || !Number.isSafeInteger(max) || max < min
            || !Number.isSafeInteger(max - min + 1)) {
            throw new Error("Integer bounds must define a valid safe integer range");
        }
        return Math.floor(this.getRandom() * (max - min + 1)) + min;
    }
    shuffleArray(array) {
        let remaining = array.length;
        while (remaining > 0) {
            const index = this.getInt(0, remaining - 1);
            remaining--;
            [array[remaining], array[index]] = [array[index], array[remaining]];
        }
        return array;
    }
}
exports.PRNG = PRNG;
